module.exports = {
  toFormat(value, format) {
    if (value === undefined) {
      return "";
    }
    let datetime = new Date(value);
    let year = datetime.getFullYear();
    let month = datetime.getMonth() + 1;
    let day = datetime.getDate();
    let hour = datetime.getHours();
    let minute = datetime.getMinutes();
    let second = datetime.getSeconds();

    let monthStr = month.toString();
    let dayStr = day.toString();
    let hourStr = hour.toString();
    let minuteStr = minute.toString();
    let secondStr = second.toString();

    let result = "";

    if (month < 10) {
      monthStr = "0" + month;
    }
    if (day < 10) {
      dayStr = "0" + day;
    }
    if (hour < 10) {
      hourStr = "0" + hour;
    }
    if (minute < 10) {
      minuteStr = "0" + minute;
    }
    if (second < 10) {
      secondStr = "0" + second;
    }
    switch (format) {
      default:
      case "YYYY-MM-DD": {
        result = `${year}-${monthStr}-${dayStr}`;
        break;
      }
      case "YYYY-MM-DD HH:mm:ss": {
        result = `${year}-${monthStr}-${dayStr} ${hourStr}:${minuteStr}:${secondStr}`;
        break;
      }
      case "YYYY-MM-DD HH:mm": {
        result = `${year}-${monthStr}-${dayStr} ${hourStr}:${minuteStr}`;
        break;
      }
      case "YYYY-MM-DD endDay": {
        result = `${year}-${monthStr}-${dayStr} 23:59:59`;
        break;
      }
      case "YYYY-MM-DD startDay": {
        result = `${year}-${monthStr}-${dayStr} 00:00:00`;
        break;
      }
      case "YYYY-MM-DD endDayNoSec": {
        result = `${year}-${monthStr}-${dayStr} 23:59`;
        break;
      }
      case "YYYY-MM-DD startDayNoSec": {
        result = `${year}-${monthStr}-${dayStr} 00:00`;
        break;
      }
      case "DD-MM-YYYY HH:mm:ss": {
        result = `${dayStr}-${monthStr}-${year} ${hourStr}:${minuteStr}:${secondStr}`;
        break;
      }
      case "HH:mm:ss": {
        result = `${hourStr}:${minuteStr}:${secondStr}`;
        break;
      }
      case "mm:ss": {
        result = `${minuteStr}:${secondStr}`;
        break;
      }
    }
    return result;
  },
  toTimestamp(value, format = "") {
    switch (format) {
      default:
      case "YYYY-MM-dd HH:mm:ss": {
        var datetime = new Date(value);
        return datetime.getTime();
      }
    }
  },
  secondToHHMMSS(value) {
    var sec_num = value ? parseInt(value, 10) : 0; // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds;
  },
  secondToMinutes(value) {
    var seconds = value / 1000;
    return seconds;
  },
  timestampToDate(value) {
    var t = new Date(value * 1000);
    return t.toLocaleString();
  },
  timeToSeconds(value) {
    var p = value.split(":"),
      s = 0,
      m = 1;

    while (p.length > 0) {
      s += m * parseInt(p.pop(), 10);
      m *= 60;
    }

    return s;
  },
  msToTime(value) {
    var milliseconds = parseInt((value % 1000) / 100),
      seconds = Math.floor((value / 1000) % 60),
      minutes = Math.floor((value / (1000 * 60)) % 60),
      hours = Math.floor(value / (1000 * 60 * 60));

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
  },
  msToHHMMSS(value) {
    var seconds = Math.floor((value / 1000) % 60),
      minutes = Math.floor((value / (1000 * 60)) % 60),
      hours = Math.floor(value / (1000 * 60 * 60));

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
  },
  msToMinu(value) {
    var minutes = Math.ceil(value / 60);
    return minutes;
  },
  getMilliSeconds(num) {
    var data = (num / 1) * 1000;
    return data;
  },
  AddMinutesToDate(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  },
  subMinutesToDate(date, minutes) {
    return new Date(date.getTime() - minutes * 60000);
  },
  pad(num) {
    return ("0" + num).slice(-2);
  },
  hhmmss(secs) {
    var minutes = Math.floor(secs / 60);
    secs = secs % 60;
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    return `${hours}:${this.pad(minutes)}:${this.pad(secs)}`;
  },
};
